module.exports = __webpack_public_path__ + "media/images/youtube-0d66b28d.png";